// extracted by mini-css-extract-plugin
module.exports = {"spinning":"style__spinning___Qi6ga","spin":"style__spin___25f_H"};